import React from "react";

import SimpleModalWithTextInput from "@src/sharedComponents/Modal/SimpleModalWithTextInput/SimpleModalWithTextInput";

interface Props {
  onClose: () => void;
  onContinue: () => void;
}

const RaiseCashWarningModal: React.FC<Props> = ({ onClose, onContinue }) => {
  return (
    <SimpleModalWithTextInput
      modalStyle={{ width: "600px" }}
      closeModal={onClose}
      title={"Tax budgets may be exceeded"}
      text={
        "If a client has a tax budget set up, the budget amount could be exceeded while raising cash. While Farther will attempt to sell overweight positions with unrealized losses first, it may be necessary to sell other securities as well to meet the requested amount - this could cause capital gains taxes in excess of the budgeted amount."
      }
      hideTextInput={true}
      confirmText={"Continue"}
      onSave={onContinue}
    />
  );
};

export default RaiseCashWarningModal;
